<script>
import { messageStore, messageDelete } from '@utils/message'
import { messageBoxDelete } from '@utils/message-box'
import cloneDeep from 'lodash/cloneDeep'

export default {
  page() {
    return {
      title: `編輯${this.$t('prepaid.BASE')}方案`,
      meta: [{ name: 'description', content: 'Edit Prepaid' }],
    }
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    tagList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: '0',
      tabList: Object.freeze([
        {
          title: '基本資訊',
          component: () => import('./components/Step1Basic'),
        },
        {
          title: '限制設定',
          component: () => import('./components/Step2Limit'),
        },
        {
          title: '適用設定',
          component: () => import('./components/Step3Available'),
        },
        {
          title: '價格設定',
          component: () => import('./components/Step4Prices'),
        },
        {
          title: '圖片設定',
          component: () => import('./components/Step5Image'),
        },
      ]),
      submitData: cloneDeep(this.defaultValue),
      tryingToSave: false,
      tryingToRemove: false,
    }
  },
  computed: {
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
  },
  mounted() {
    this.$meta().refresh()
  },
  created() {},
  methods: {
    async onClickSave(type) {
      this.tryingToSave = true
      const primaryServicesHasProductId = this.submitData.prices.some((price) => price.productIds.length)
      const bonusServicesHasProductId = this.submitData.bonusPrices.some((price) => price.productIds.length)
      try {
        if (this.submitData.prices.length && !primaryServicesHasProductId) {
          await this.$confirm('購買項目未選擇適用店家', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.tryingNextStep = false
          return
        }
        if (this.submitData.bonusPrices.length && !bonusServicesHasProductId) {
          //   const productId = this.submitData.prices[0].productIds
          //   this.submitData.bonusPrices.forEach((price) => {
          //     price.productIds = productId
          //   })
          await this.$confirm('贈送項目未選擇適用店家', '提示', {
            confirmButtonText: '確定',
            showCancelButton: false,
            type: 'warning',
            center: true,
          })
          this.tryingNextStep = false
          return
        }
        if (this.$refs.step0) {
          await this.$refs.step0.validate()
        }
        if (this.$refs.step1) {
          for (let i = 0; i < this.submitData.usageRules.length; i++) {
            await this.$refs.step1.$refs[`form${i}`][0].validate()
          }
        }

        this.submitData = {
          ...this.submitData,
          images: this.submitData.images.map((image, index) => {
            return {
              ...image,
              default: index === 0 ? 1 : 0,
            }
          }),
        }
        // console.log('this.submitData::::',this.submitData)
        await this.validateSubmitDataPrice()
        await this.$store.dispatch('prepaid/storeGroup', this.submitData)
        this.$emit('renewLeftInfo')
        messageStore('edit')
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingToSave = false
      }
    },
    /**
     * @description 驗證提交出去的服務資料們
     */
    validateSubmitDataPrice() {
      return new Promise((resolve, reject) => {
        if (this.submitData.prices.length === 0) {
          this.$message({ message: '請選擇一筆服務!', type: 'error' })
          throw new Error('請選擇一筆服務')
        } else {
          resolve()
        }
      })
    },
    async tryToRemove() {
      try {
        await messageBoxDelete(`該${this.$t('prepaid.BASE')}方案`)
        try {
          this.tryingToRemove = true
          // await this.$store.dispatch('prepaid/remove', { ids: [this.defaultValue.id] })
          await this.$store.dispatch('prepaid/removeGroup', { groupOrderings: [this.defaultValue.groupOrdering] })
          messageDelete()
          this.$router.push({ name: 'prepaid' })
        } finally {
          this.tryingToRemove = false
        }
      } catch {}
    },
    async beforeTabSwitch(activeName, oldActiveName) {
      if (oldActiveName === '1') {
        for (let i = 0; i < this.submitData.usageRules.length; i++) {
          await this.$refs.step1.$refs[`form${i}`][0].validate()
        }
      }
    },
  },
}
</script>
<template>
  <div :class="$style.page">
    <!-- <BasePageHeader title="編輯包月方案" /> -->
    <el-tabs v-model="activeTab" type="border-card" stretch class="isStyleBase" :before-leave="beforeTabSwitch">
      <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`"> </el-tab-pane>
    </el-tabs>
    <keep-alive>
      <component
        :is="tabList[activeTab].component"
        :ref="`step${activeTab}`"
        :class="$style.pageContent"
        :default-value.sync="submitData"
        :products="products"
        :category="category"
        :prices="prices"
        :tag-list="tagList"
        @update="onClickSave('image')"
      />
    </keep-alive>
    <div :class="$style.footer">
      <el-button class="is-round" type="danger" :loading="tryingToRemove" :disabled="tryingToRemove" @click="tryToRemove">刪除</el-button>
      <el-button class="is-round" :loading="tryingToSave" @click="$router.push({ name: 'prepaid' })">取消</el-button>
      <el-button class="is-round" type="primary" :loading="tryingToSave" @click="onClickSave">儲存變更</el-button>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
